const STORAGE_KEY = 'bonusly:give-box-draft';
const EXPIRATION_MS = 20_000; // 20 seconds

interface DraftData {
	content: unknown;
	attachment?: unknown;
	privacy?: string;
	savedAt: number;
}

export interface LoadedDraft {
	content: unknown;
	attachment?: unknown;
	privacy?: string;
}

export const saveDraft = (content: unknown, attachment?: unknown, privacy?: string): void => {
	if (!content) return;

	try {
		const data: DraftData = {
			content,
			attachment: attachment ?? undefined,
			privacy: privacy ?? undefined,
			savedAt: Date.now(),
		};
		localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
	} catch {
		// Silently fail if localStorage is unavailable
	}
};

export const clearDraft = (): void => {
	try {
		localStorage.removeItem(STORAGE_KEY);
	} catch {
		// Silently fail if localStorage is unavailable
	}
};

export const loadDraft = (): LoadedDraft | null => {
	try {
		const raw = localStorage.getItem(STORAGE_KEY);
		if (!raw) return null;

		const data: DraftData = JSON.parse(raw);
		const isExpired = Date.now() - data.savedAt > EXPIRATION_MS;

		if (isExpired) {
			clearDraft();
			return null;
		}

		return {
			content: data.content,
			attachment: data.attachment,
			privacy: data.privacy,
		};
	} catch {
		// Silently fail if localStorage is unavailable or data is corrupted
		return null;
	}
};
